import { useState } from 'react';
import bgWhyBpr from '../../assets/img/whybpr.png';

export default function VisiMisi() {
    const [openAccordion, setOpenAccordion] = useState(null);

    const handleAccordionClick = (id: any) => {
        setOpenAccordion(openAccordion === id ? null : id);
    };

    return (
        <div className="bg-cover bg-center min-h-[700px]" style={{ backgroundImage: `url(${bgWhyBpr})` }}>
            <div className='max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16'>
                <div className='mt-10'>
                    <span className="text-xl font-poppinsBold ">VISI</span>
                    <p className='text-lg text-textPrimary text-justify mt-3 max-w-lg'>
                        Menjadi Bank Pilihan Rakyat dalam menyediakan layanan keuangan yang selalu dibutuhkan, tumbuh, sehat, dan terpercaya serta meningkatkan nilai finansial bagi para stakeholder.
                    </p>
                </div>
                <div className='mt-10 max-w-xl'>
                    <span className="text-xl font-poppinsBold ">MISI</span>
                    <div id="accordion-flush">
                        {[{
                            id: 2,
                            title: "Memberikan pelayanan.",
                            content: "Memberikan pelayanan prima kepada masyarakat dan usaha mikro, kecil, dan menengah"
                        }, {
                            id: 3,
                            title: "Tata kelola.",
                            content: "Memiliki tata kelola yang baik dan profesional"
                        }, {
                            id: 4,
                            title: "SDM",
                            content: "Meningkatkan kualitas dan peran serta Sumber Daya Manusia yang ada dalam pencapaian target bersama"
                        }].map(item => (
                            <div key={item.id}>
                                <h2 id={`accordion-flush-heading-${item.id}`}>
                                    <button
                                        type="button"
                                        className="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-500 border-b border-black dark:border-gray-700 dark:text-gray-400 gap-3"
                                        onClick={() => handleAccordionClick(item.id)}
                                    >
                                        <span>{item.title}</span>
                                        <svg
                                            data-accordion-icon
                                            className={`w-3 h-3 ${openAccordion === item.id ? 'rotate-180' : ''} shrink-0`}
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 10 6"
                                        >
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5L5 1 1 5" />
                                        </svg>
                                    </button>
                                </h2>
                                <div
                                    id={`accordion-flush-body-${item.id}`}
                                    className={`${openAccordion === item.id ? 'block' : 'hidden'}`}
                                    aria-labelledby={`accordion-flush-heading-${item.id}`}
                                >
                                    <div className="py-5 border-b border-gray-950 dark:border-gray-700">
                                        <p className="text-gray-500 dark:text-gray-400">{item.content}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
